'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * BaseButton
 *
 */


var ButtonBase = function (_Component) {
  _inherits(ButtonBase, _Component);

  function ButtonBase() {
    _classCallCheck(this, ButtonBase);

    return _possibleConstructorReturn(this, (ButtonBase.__proto__ || Object.getPrototypeOf(ButtonBase)).apply(this, arguments));
  }

  _createClass(ButtonBase, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          pill = _props.pill,
          inverse = _props.inverse,
          block = _props.block,
          srOnlyLabel = _props.srOnlyLabel,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['size', 'pill', 'inverse', 'block', 'srOnlyLabel', 'className']);

      var buttonClasses = (0, _classnames2.default)('btn', className, _defineProperty({
        'btn-rounded': pill,
        'btn-inverse': inverse,
        'btn-block': block
      }, 'btn-' + size, size));
      var labelClasses = (0, _classnames2.default)('btn__label', {
        'sr-only': srOnlyLabel
      });

      if (this.props.href) {
        return _react2.default.createElement('a', _extends({
          className: buttonClasses
        }, rest), _react2.default.createElement('span', {
          className: labelClasses
        }, this.props.label), this.props.children);
      }

      return _react2.default.createElement('button', _extends({
        className: buttonClasses
      }, rest), _react2.default.createElement('span', {
        className: labelClasses
      }, this.props.label), this.props.children);
    }
  }]);

  return ButtonBase;
}(_react.Component);

ButtonBase.propTypes = {
  /** Flags for if the button is .btn-block (span the full width of a parent) */
  block: _propTypes2.default.bool,

  /** Flag for if the button is disabled */
  disabled: _propTypes2.default.bool,

  /** Flag for if the button is pill shaped and receives .btn-rounded */
  pill: _propTypes2.default.bool,

  /** Flag for if the button is is inverse-styled and receives className .btn-inverse */
  inverse: _propTypes2.default.bool,

  /** If href is specified, the component outputs an <a> tag,
    * otherwise, it is a button tag. */
  href: _propTypes2.default.string,

  /** The text or html to display on the button, required. */
  label: _propTypes2.default.node.isRequired,

  /** Size variation from Baseline. */
  size: _propTypes2.default.oneOf(['xs', 'sm', 'lg']),

  /** Flag for applying .sr-only class to the button label for Screen Readers */
  srOnlyLabel: _propTypes2.default.bool,

  /** Specify the type of button. One of: 'button'|'submit'|'reset' */
  type: _propTypes2.default.oneOf(['button', 'submit', 'reset'])
};
ButtonBase.defaultProps = {
  type: 'button',
  pill: true
};
exports.default = ButtonBase;